import { Children, cloneElement } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Item } from './item'

import { base } from '../../mixins'

const fontSizes = {
  small: '16px',
  medium: '20px',
  variant: {
    'smaller-text': {
      small: null,
      medium: '16px'
    },
    'leading-down': {
      small: null,
      medium: '18px'
    }
  }
}
const lineHeights = {
  small: '18px',
  medium: '24px',
  variant: {
    'smaller-text': {
      small: null,
      medium: '18px'
    },
    'leading-down': {
      small: null,
      medium: '22px'
    }
  }
}
const getFontSize = ({ size, variant }) => {
  return fontSizes.variant[variant]?.[size] ?? fontSizes[size]
}
const getLineHeight = ({ size, variant }) => {
  return lineHeights.variant[variant]?.[size] ?? lineHeights[size]
}
const List = styled.ul`
  ${base};
  margin: 0;
  padding: 0;
  font-size: ${getFontSize};
  line-height: ${getLineHeight};
  color: ${({ color }) => color};
  list-style-position: inside;
`
/**
 * The Checklist renders an unordered list of checkmarked items.
 */
const Checklist = ({ children, variant, size = 'medium', color = 'black', ...rest }) => {
  return (
    <List color={color} size={size} variant={variant} {...rest}>
      {Children.map(children, item => {
        const props = { ...item.props }

        if (!props.size) {
          props.size = size
        }

        if (!props.color) {
          props.color = color
        }

        if (!props.variant && variant) {
          props.variant = variant
        }

        return cloneElement(item, props)
      })}
    </List>
  )
}

Checklist.propTypes = {
  /** Sets the relative size of the text and checkbox. */
  size: PropTypes.oneOf(['small', 'medium']),
  /** Sets the text color. */
  color: PropTypes.string,
  /** Applies a variant to the general styling. */
  variant: PropTypes.oneOf(['smaller-text', 'leading-down'])
}

Checklist.Item = Item

export { Checklist }
